import { FC, ReactNode } from 'react'
import { NoDataCard } from 'views/components/Board/NoDataCard'
import { TripCard } from './TripsCard'
import { Panel, Progress } from '@agro-club/agroclub-shared'
import { AntTagColor } from '@agro-club/agroclub-shared/dist/cjs/ui/misc/AntTag/types'
import { CollapseHeaderWithCount } from 'views/components/CollapseHeaderWithCount/CollapseHeaderWithCount'
import { PreloadCard } from 'views/components/Board/Preload'
import { LogisticsKRTrip } from 'views/pages/LogisticsKR/types'
import { WrapperCards } from 'views/pages/LogisticsKR/LogisticRequests/styled'

type Props = {
  trips: LogisticsKRTrip[]
  key: string
  title: ReactNode
  counter: number
  progress: Progress
  tagColor?: AntTagColor
}

export const Trips: FC<Props> = ({ trips, counter, tagColor, title, progress, ...props }) => {
  const preloadWrapper = progress === Progress.WORK && <PreloadCard />

  return (
    <Panel
      {...props}
      header={<CollapseHeaderWithCount progress={progress} tagColor={tagColor} counter={counter} title={title} />}
    >
      <WrapperCards>
        {!preloadWrapper && trips.map((trip) => <TripCard key={trip.id} trip={trip} />)}
        {preloadWrapper}
        {!trips.length && !preloadWrapper && <NoDataCard />}
      </WrapperCards>
    </Panel>
  )
}
